import { render, staticRenderFns } from "./ManageProjectRoles.vue?vue&type=template&id=43fffe94"
import script from "./ManageProjectRoles.vue?vue&type=script&lang=js"
export * from "./ManageProjectRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports